import React from 'react';
import styles from './VotingSession.module.css';
import classNames from 'classnames';
import type VotingSessionWidget from '../../../widgets/VotingSessionWidget';
import { ApplicationView } from '@aha-app/mvc';
import FistToFiveResult from './FistToFiveResult';
import { type RecordId } from '../../../shared-types';

const FistToFiveVotingSessionResults: React.FC<{
  widget: VotingSessionWidget;
}> = ({ widget }) => {
  if (!widget) return null;

  const votes = widget.votesByObjectAndUser()[widget.id] ?? {};
  const count = Object.keys(votes).length;
  const average =
    count > 0 ? Object.values(votes).reduce((acc, v) => acc + v, 0) / count : 0;
  const wholePart = Math.floor(average);
  const decimalPart = (average - wholePart).toFixed(2).slice(1);

  const histogram: Array<Array<RecordId>> = [];
  let highScore = 0;

  for (const [voterId, vote] of Object.entries(votes) as [RecordId, number][]) {
    if (histogram[vote]) {
      histogram[vote].push(voterId);
    } else {
      histogram[vote] = [voterId];
    }

    if (histogram[vote].length > highScore) {
      highScore = histogram[vote].length;
    }
  }

  return (
    <div>
      <div
        className={classNames(
          'pb-1 pl-2 pr-1 mb-1 flex-row flex-row--justify-space-between color-secondary',
          styles.votingResultsHeader
        )}
      >
        <span>Details</span>{' '}
        <span className='flex-row gap-3'>
          <span>Average</span>
          <span className='h-100 color-primary'>
            {wholePart}
            <span className='h-300'>{decimalPart}</span>
          </span>
        </span>
      </div>
      <ol
        className={classNames('side-panel__list', styles.votingResultSummary)}
      >
        {histogram.map(
          (voters, i) =>
            voters && (
              <FistToFiveResult
                key={`result-${i}`}
                widget={widget}
                value={i}
                voterIds={voters}
                winner={voters.length === highScore}
              />
            )
        )}
      </ol>
    </div>
  );
};

export default ApplicationView(FistToFiveVotingSessionResults);
